// extracted by mini-css-extract-plugin
export default {"stock-audit-report-container":"MedicineWiseStockAuditReport_stock-audit-report-container__QzpjG"};